"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = function styles(theme) {
  return {
    root: {
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: '100%',
      padding: theme.spacing.unit * 2.2,
      background: theme.palette.bottomDialogBackground
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing.unit * 1.2,
      top: theme.spacing.unit * 1.2,
      width: 50,
      color: theme.palette.primary.contrastText
    },
    primaryButton: {
      marginTop: theme.spacing.unit * 2,
      display: 'block'
    },
    textField: {
      width: '40%',
      marginTop: theme.spacing.unit * 2.2
    },
    input: {
      color: theme.palette.primary.contrastText
    },
    disclaimer: {
      marginRight: theme.spacing.unit * 1.5,
      color: theme.palette.primary.contrastText,
      maxHeight: 75,
      overflow: 'auto'
    },
    header: {
      color: theme.palette.primary.contrastText,
      textTransform: 'capitalize'
    },
    errorMessage: {
      minHeight: '1em',
      color: theme.palette.error.main,
      fontSize: '16px'
    }
  };
};

var SignatureTOSDialog = /*#__PURE__*/function (_Component) {
  _inherits(SignatureTOSDialog, _Component);

  function SignatureTOSDialog() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SignatureTOSDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SignatureTOSDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fieldContent: '',
      errorMessage: null,
      hasFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "checkFocus", function (props) {
      if (!_this.state.hasFocused && props.isOpen && _this.textInput) {
        _this.textInput.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        fieldContent: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (_ref) {
      var key = _ref.key;

      if (key === 'Enter') {
        _this.handleSubmit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var _this$props = _this.props,
          actor = _this$props.actor,
          _this$props$config$fi = _this$props.config.field._derived,
          isInitials = _this$props$config$fi.isInitials,
          isValidated = _this$props$config$fi.isValidated,
          upstreamHandleSubmit = _this$props.handleSubmit;
      var fieldContent = _this.state.fieldContent;
      fieldContent = "".concat(fieldContent).trim();

      if (isValidated) {
        var expectedContent = isInitials ? actor.initials : actor.name;

        if (fieldContent.toLowerCase() !== expectedContent.toLowerCase()) {
          var errorMessage = isInitials ? "Please enter your initials as recorded in your profile: ".concat(expectedContent) : "Please enter your full legal name as recorded in your profile: ".concat(expectedContent);

          _this.setState({
            errorMessage: errorMessage
          });

          return;
        }
      }

      _this.setState({
        errorMessage: null,
        hasFocused: false
      });

      upstreamHandleSubmit(fieldContent);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var handleClose = _this.props.handleClose;

      _this.setState({
        hasFocused: false,
        fieldContent: '',
        errorMessage: null
      });

      handleClose();
    });

    return _this;
  }

  _createClass(SignatureTOSDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkFocus(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Only focus on the text if it was closed and we are opening it
      this.checkFocus(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$config = _this$props2.config,
          config = _this$props2$config === void 0 ? {} : _this$props2$config,
          classes = _this$props2.classes,
          signatureTOS = _this$props2.signatureTOS;

      var _ref2 = config || {},
          field = _ref2.field,
          open = _ref2.open;

      var _this$state = this.state,
          fieldContent = _this$state.fieldContent,
          errorMessage = _this$state.errorMessage;

      var _ref3 = field || {},
          _ref3$_derived = _ref3._derived;

      _ref3$_derived = _ref3$_derived === void 0 ? {} : _ref3$_derived;
      var isInitials = _ref3$_derived.isInitials;
      return _react.default.createElement(_Drawer.default, {
        open: open,
        anchor: "bottom"
      }, _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_Typography.default, {
        variant: "h5",
        gutterBottom: true,
        className: classes.header,
        "data-test-id": "SignatureTOSDialog-title"
      }, isInitials ? 'INITIALS' : 'SIGNATURE'), _react.default.createElement(_Button.default, {
        className: classes.closeButton,
        onClick: this.handleClose,
        tabIndex: "-1",
        "data-test-id": "SignatureTOSDialog-closeButton"
      }, _react.default.createElement(_icons.Close, null)), _react.default.createElement(_Typography.default, {
        component: "p",
        className: classes.disclaimer
      }, signatureTOS), _react.default.createElement(_TextField.default, {
        autoFocus: true,
        className: classes.textField,
        inputRef: function inputRef(ref) {
          _this2.textInput = ref;
        },
        label: isInitials ? 'Initials' : 'Full Legal Name',
        onChange: function onChange(e) {
          return _this2.handleChange(e);
        },
        "data-test-id": "SignatureTOSDialog-textField",
        InputProps: {
          className: classes.input,
          inputProps: {
            'data-test-id': 'SignatureTOSDialog-input'
          }
        },
        onKeyPress: this.onKeyPress
      }), _react.default.createElement(_Button.default, {
        className: classes.primaryButton,
        color: "primary",
        variant: "contained",
        onClick: this.handleSubmit,
        disabled: !"".concat(fieldContent).trim(),
        "data-test-id": "SignatureTOSDialog-submitButton"
      }, "I Agree"), _react.default.createElement(_Typography.default, {
        color: "primary",
        type: "body",
        className: classes.errorMessage,
        "data-test-id": "SignatureTOSDialog-errorMessage"
      }, errorMessage)));
    }
  }]);

  return SignatureTOSDialog;
}(_react.Component);

_defineProperty(SignatureTOSDialog, "propTypes", {
  config: _propTypes.default.shape({
    field: _propTypes.default.object,
    open: _propTypes.default.bool.isRequired
  }),
  classes: _propTypes.default.object.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  actor: _propTypes.default.shape({
    name: _propTypes.default.string,
    initials: _propTypes.default.string
  }).isRequired,
  signatureTOS: _propTypes.default.string
});

_defineProperty(SignatureTOSDialog, "defaultProps", {
  signatureTOS: "Only the person associated with these records is permitted to use this system through this account.  Completion and submission of the online forms available through this system will create legally binding obligations associated with each form. Please read each form carefully.  Execution of each form will be accomplished through clicking on the \u201CI Agree\u201D button provided at the bottom of each form.  By clicking \u201CI Agree\u201D at the bottom of each form, you will be acknowledging that you have read the applicable form, understand the requirements for submission of the information, agree to submit complete and accurate information, and further agree to submit and sign these forms electronically through this system."
});

var _default = (0, _styles.withStyles)(styles)(SignatureTOSDialog);

exports.default = _default;